module.exports = __webpack_public_path__ + "img/bt-3-on.bb638ffc.png";